import VersaoDeDados from "@/controller/versaoDeDados";
import buscarPneusDinamicos from "@/services/vex/buscarPneus";
import camposPersonalizados from "@/services/vex/camposFixos";
import enterpriseConfig from "@/services/vex/enterpriseConfig";
import { getPhotosTemplate } from "@/services/vex/fotosVistoria";
import getGruposDoUsuario from "@/services/vex/gruposDoUsuario";
import getLogo from "@/services/vex/logo";
import getParametrosEmpresa from "@/services/vex/parametrosEmpresa";
import questionariosComPerguntas from "@/services/vex/questionariosComPerguntas";
import store from "@/store/store";

async function saveEnterpriseInfo(token, userInfo) {
    let enterpriseInfo = {
        name: token,
        id: userInfo.id,
        userName: userInfo.nome,
        type: userInfo.tipo,
        active: userInfo.ativo,
    };

    localStorage.setItem("enterprise", JSON.stringify(enterpriseInfo));
}

async function saveLogo(token) {
    let logo = await getLogo(token);
    localStorage.setItem("enterpriseLogo", logo);
}

async function saveOperations(token) {
    const buscarTiposDeOperacao = (await import("@/services/vex/tiposOperacao")).default;
    let operationsList = await buscarTiposDeOperacao(token);
    operationsList = operationsList.map((operation) => {
        let objParams = {};
        for(const param of operation.parametros) {
            objParams[param.identificador.toLowerCase()] = {
                ...param,
                ativo: param.ativo === "1" || param.ativo === true || param.ativo === 1,
                ordem: parseInt(param.ordem),
                id: parseInt(param.id),
                tipos_vistoria_compativeis: param.tipos_vistoria_compativeis != null
                    ? JSON.parse("[" + param.tipos_vistoria_compativeis + "]")
                    : null
            };
        }

        return {
            ...operation,
            parametros: objParams
        };
    });

    localStorage.setItem("operations", JSON.stringify(operationsList));
}

async function saveQuestionarios(token) {
    try {
        let listaQuestionarios = await questionariosComPerguntas(token);
        localStorage.setItem("quizzes", JSON.stringify(listaQuestionarios));
    } catch (error) {
        console.error("saveQuestionarios", error);
    }
}

async function saveParametrosEmpresa(token) {
    try {
        let parametrosEmpresa = await getParametrosEmpresa(token);
        localStorage.setItem("parametrosEmpresa", JSON.stringify(parametrosEmpresa));
    } catch (error) {
        console.error("saveParametrosEmpresa", error);
    }
}

async function saveUserGroups(token) {
    try {
        let userId = JSON.parse(localStorage.getItem("enterprise")).id;

        let userGroups = await getGruposDoUsuario(userId, token);
        localStorage.setItem("userGroups", JSON.stringify(userGroups));
    } catch (error) {
        console.error("saveUserGroups", error);
    }

}

async function saveEnterpriseConfig(token) {
    const enterpriseConfiguration = await enterpriseConfig(token);
    localStorage.setItem("enterpriseConfig", JSON.stringify(enterpriseConfiguration));
    localStorage.setItem("userGroupsEnabled", JSON.stringify(enterpriseConfiguration.utiliza_grupo_usuario.valor === "1"));
}

async function saveCamposPersonalizados(token) {
    let campos = await camposPersonalizados(token);
    localStorage.setItem("dataFields", JSON.stringify(campos));
}

function saveEnterpriseId() {
    //adding enterprise id to enterprise on localstorage and store
    let quizzes = JSON.parse(localStorage.getItem("quizzes"));
    const enterpriseId = quizzes[0].idEmpresa;

    let enterprise = JSON.parse(localStorage.getItem("enterprise"));
    enterprise.idEnterprise = parseInt(enterpriseId);
    localStorage.setItem("enterprise", JSON.stringify(enterprise));

    store.commit("setIdEnterprise", enterpriseId);
}

async function savePhotosTemplates() {
    const enterpriseId = store.state.enterprise.idEnterprise;

    let quizzes = JSON.parse(localStorage.getItem("quizzes"));
    let photosTemplates = {};
    let photosArray;
    for (let i = 0; i < quizzes.length; i++) {
        const quiz = quizzes[i];
        let quizAtivo = quiz.status == "ATIVO";

        //Retrieve an array containig all photos of the selected quiz type if quizAtivo
        if (quizAtivo) {
            photosArray = await getPhotosTemplate(enterpriseId, quiz.id);
            photosTemplates[quiz.id] = photosArray;
        }
    }
    localStorage.setItem("photosTemplates", JSON.stringify(photosTemplates));
}

async function savePhotos() {
    const templates = JSON.parse(localStorage.getItem("photosTemplates"));

    for (let i = 0; i < Object.keys(templates).length; i++) {
        const template = templates[Object.keys(templates)[i]];

        for (let j = 0; j < template.length; j++) {
            let photoUrl = template[j].urlArquivo;
            if(photoUrl.slice(-1) !== "/") {
                photoUrl = photoUrl + "/";
            }

            try {
                await fetch(photoUrl).then((response) =>
                    caches
                        .open("photosImages")
                        .then((cache) => cache.put(photoUrl, response))
                );
            } catch (error) {
                console.error(error);
            }
        }
    }
}

function updateDownloadAllVexDataStatus(newStatus, newPercentage) {
    let status = {
        status: newStatus,
        percentage: newPercentage,
    };
    store.commit("setDownloadAllVexDataStatus", status);
}

async function downloadAllVexData(token, userInfo = null, shouldSaveUserInfo = false) {
    let versaoDeDados = new VersaoDeDados();

    let estagios = [];

    if(shouldSaveUserInfo) {
        estagios.push({
            nome: "Salvando informações",
            metodo: saveEnterpriseInfo,
            args: [token, userInfo]
        });
    }

    estagios = [
        ...estagios,
        {
            nome: "Salvando logo",
            metodo: saveLogo,
            args: [token]
        },
        {
            nome: "Salvando tipos de operação",
            metodo: saveOperations,
            args: [token]
        },
        {
            nome: "Salvando questionários",
            metodo: saveQuestionarios,
            args: [token]
        },
        {
            nome: "Salvando dados de integração",
            metodo: saveParametrosEmpresa,
            args: [token]
        },
        {
            nome: "Salvando campos personalizados",
            metodo: saveCamposPersonalizados,
            args: [token]
        },
        {
            nome: "Salvando configurações da empresa",
            metodo: saveEnterpriseConfig,
            args: [token]
        },
        {
            nome: "Salvando configurações da empresa",
            metodo: saveEnterpriseId,
            args: []
        },
        {
            nome: "Salvando grupos do usuário",
            metodo: saveUserGroups,
            args: [token]
        },
        {
            nome: "Salvando templates de fotos",
            metodo: savePhotosTemplates,
            args: []
        },
        {
            nome: "Salvando fotos",
            metodo: savePhotos,
            args: []
        },
        {
            nome: "Atualizando versão de dados",
            metodo: versaoDeDados.setVersaoDadosLocal,
            args: []
        },
        {
            nome: "Carregando dados adicionais",
            metodo: buscarPneusDinamicos,
            args: []
        },
        {
            nome: "Finalizado",
            metodo: () => {},
            args: []
        }
    ];

    const quantiaDeEstagios = estagios.length;

    for await(const [index, estagio] of estagios.entries()) {
        await estagio.metodo(...estagio.args);
        updateDownloadAllVexDataStatus(estagio.nome, 100 * ((index + 1) / quantiaDeEstagios));
    }

    return true;
}

export default downloadAllVexData;
